import React, { Fragment, useEffect } from 'react';
import Switch from 'react-switch';
import PropTypes from 'prop-types';
import { connect } from 'react-redux'
import spaceActions from 'actions/spaces/actions'


const SpaceList = ({ fetchSpacesVenue, list, setAction, venueId, editSpacePublish, setSpaceId, name }) => {
  useEffect(() => {
    if (venueId) {
      fetchSpacesVenue(venueId)
    }
  }, [])

  const handleSpaceClick = (action, spaceId) => {
    setSpaceId(spaceId)
    setAction(action)
  }

  const renderNewSpace = () => (
    <div className="w-1/3 p-5">
      <div className="w-full cursor-pointer h-full border rounded-lg flex justify-center items-center" onClick={() => handleSpaceClick('add')}>
        <div className="text-center">
          <i className="fa fa-plus text-gray-500 text-3xl" aria-hidden="true"></i>
          <p className="text-gray-500">List a Space</p>
        </div>
      </div>
    </div>
  )

  const handlePublishChange = (publish, id) => {
    editSpacePublish({ publish, id })
  }

  const renderSpaces = () => (
    <div className="space-list flex flex-wrap">
      {renderNewSpace()}
      {list.map((item, key) => {
        return (
          <div className="space w-1/3" key={key}>
            <div className="m-5 relative">
              <Fragment>
                <img alt="space list" src={item.images.length ? `${item.images[0].path}` : `${require('assets/images/no-image.jpg')}`}
                  className="h-48 cursor-pointer w-full rounded-t-lg" onClick={() => handleSpaceClick('edit', item.id)} />
                {!item.approved && <div className="absolute text-xl font-medium text-white inset-0 h-48 expert-dark rounded-t-md flex items-center justify-center">
                  Review in Progress
                  <i className="fa fa-question-circle ml-2" aria-hidden="true"></i>
                </div>}
                {item.approved && <div className="absolute font-medium top-0 right-0 h-48 rounded-t-md">
                  <div className="flex border rounded-md border-gray-100 text-xs m-3 py-1 px-2 items-center" style={{ backgroundColor: '#EBEBEB' }}>
                    Available?
                    <Switch
                      onColor="#02d650"
                      offColor="#e6e8e7"
                      onChange={(e) => handlePublishChange(e, item.id)}
                      checked={item.published}
                      className="switch-button ml-1"
                      name={`switch-${key}`}
                      width={60}
                      height={23}
                      checkedIcon={(<div className="h-full text-white flex items-center justify-center text-xs">YES</div>)}
                      uncheckedIcon={(<div className="h-full text-white flex items-center justify-center text-xs">NO</div>)}
                    ></Switch>
                  </div>
                </div>}
                <div className="text-center border rounded-b-lg py-2">
                  <p onClick={() => handleSpaceClick('edit', item.id)} className="text-base text-gray-900 leading-normal py-2 cursor-pointer">{item.title}</p>
                  <a rel='noreferrer' target="_blank" href={item.public_path} className="text-blue-400 underline text-xs pb-2">Preview Space</a>
                </div>
              </Fragment>
            </div>
          </div>
        )
      })}
    </div>
  )

  return (
    <div className="venue-space">
      <h5 className="font-bold">{ name }</h5>
      {renderSpaces()}
    </div>
  )
}

SpaceList.propTypes = {
  fetchSpacesVenue: PropTypes.func,
  list: PropTypes.array,
  setAction: PropTypes.func,
  venueId: PropTypes.number,
  editSpacePublish: PropTypes.func,
  setSpaceId: PropTypes.func,
  name: PropTypes.string
}

const mapStateToProps = ({ space, venue }) => ({
  list: space.spaceVenueList,
  name: venue.details.name
})

const mapDispatchToProps = {
  fetchSpacesVenue: spaceActions.fetchSpacesVenue,
  editSpacePublish: spaceActions.editSpacePublish
}

export default connect(mapStateToProps, mapDispatchToProps)(SpaceList)
